import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, concatMap, of, throwError } from 'rxjs';

import { RwcInterceptor } from './rwc-interceptor';

export function convertToHttpInterceptor(rwcInterceptor: RwcInterceptor): HttpInterceptor {
    return {
        intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
            if (!rwcInterceptor.appliesToRequest || rwcInterceptor.appliesToRequest(req)) {
                const observable = rwcInterceptor.interceptRequest ? rwcInterceptor.interceptRequest(req) : of(req);

                return observable.pipe(
                    concatMap(request => next.handle(request)),
                    concatMap(response => {
                        if (rwcInterceptor.interceptResponse) {
                            return rwcInterceptor.interceptResponse(req, response);
                        }
                        return of(response);
                    }),
                    catchError((errorResponse: HttpErrorResponse) => {
                        if (rwcInterceptor.interceptResponseError) {
                            return rwcInterceptor.interceptResponseError(req, errorResponse);
                        }
                        return throwError(() => errorResponse);
                    })
                );
            }
            return next.handle(req);
        }
    };
}
export const rwc2HttpInterceptor = <T extends RwcInterceptor>(interceptor: T): HttpInterceptor =>
    convertToHttpInterceptor(interceptor);
